import React from 'react';
import Icon from '../../../components/AppIcon';
import { erpIntegrationService } from '../../../services/erpIntegrationService';

const SyncOverviewDashboard = ({ connection, syncSessions }) => {
  const recentSessions = syncSessions?.slice(0, 5) || [];
  const totalSessions = syncSessions?.length || 0;
  const completedSessions = syncSessions?.filter(s => s?.sessionStatus === 'completed')?.length || 0;
  const failedSessions = syncSessions?.filter(s => s?.sessionStatus === 'failed')?.length || 0;
  const totalRecords = syncSessions?.reduce((sum, s) => sum + (s?.totalRecords || 0), 0);

  const stats = [
    {
      label: 'Active Connection',
      value: connection ? erpIntegrationService?.getERPSystemLabel(connection?.erpSystem) : 'None',
      icon: 'Link',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Total Syncs',
      value: totalSessions,
      icon: 'RefreshCw',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Success Rate',
      value: totalSessions > 0 ? `${((completedSessions / totalSessions) * 100)?.toFixed(1)}%` : '0%',
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Records Synced',
      value: totalRecords?.toLocaleString(),
      icon: 'Database',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold text-foreground mb-6">Synchronization Overview</h2>
      
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {stats?.map((stat, index) => (
          <div key={index} className="bg-background border border-border rounded-lg p-5">
            <div className="flex items-center justify-between mb-3">
              <div className={`${stat?.bgColor} ${stat?.color} p-3 rounded-lg`}>
                <Icon name={stat?.icon} size={24} />
              </div>
            </div>
            <div className="text-2xl font-bold text-foreground mb-1">{stat?.value}</div>
            <div className="text-sm text-muted-foreground">{stat?.label}</div>
          </div>
        ))}
      </div>

      {/* Recent Sync Sessions */}
      <div className="bg-background border border-border rounded-lg p-5">
        <h3 className="text-lg font-semibold text-foreground mb-4">Recent Sync Sessions</h3>
        <div className="space-y-3">
          {recentSessions?.map((session) => (
            <div key={session?.id} className="flex items-center justify-between p-4 bg-card border border-border rounded-lg">
              <div className="flex-1">
                <h4 className="font-medium text-foreground mb-1">{session?.sessionName}</h4>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    {new Date(session?.payPeriodStart)?.toLocaleDateString()} - {new Date(session?.payPeriodEnd)?.toLocaleDateString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Users" size={14} />
                    {session?.totalRecords} employees
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="text-right">
                  <div className="text-sm font-medium text-foreground">
                    {session?.processedRecords}/{session?.totalRecords}
                  </div>
                  <div className="text-xs text-muted-foreground">Processed</div>
                </div>
                <span className={`px-3 py-1 rounded text-xs font-medium ${
                  session?.sessionStatus === 'completed' ? 'bg-success/10 text-success' :
                  session?.sessionStatus === 'failed' ? 'bg-error/10 text-error' :
                  session?.sessionStatus === 'processing'? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground'
                }`}>
                  {session?.sessionStatus}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SyncOverviewDashboard;
